import { writable } from 'svelte/store'

export const uploadPanelState = writable('upload')

export const processedImages = writable()

export const singleColourLogoColour = writable('(0,0,0)')

export const selectedImage = writable(null)

export const selectedCategory = writable('original')

export const selectedVersion = writable('original')
